module.exports = __webpack_public_path__ + "img/b_Rentrit_left.eea895f4.jpeg";